"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRoundShortTitle = void 0;
const constants_1 = require("../constants");
const enums_1 = require("../enums");
const generateRoundShortTitle = (index, roundCounts, type) => {
    const eliminationNormalizer = type === enums_1.TournamentType.DoubleEliminationTournament ? 1 : 0;
    if (typeof index !== 'number' || typeof roundCounts !== 'number') {
        return '';
    }
    if (index < 1) {
        return `Round ${index + 1}`;
    }
    if (roundCounts > 4 && index === roundCounts - constants_1.QUARTER_FINALS_END_POSITION - eliminationNormalizer) {
        return 'Quarter Finals';
    }
    if (roundCounts > 3 && index === roundCounts - constants_1.SEMI_FINALS_END_POSITION - eliminationNormalizer) {
        return 'Semi-Finals';
    }
    if (index === roundCounts - constants_1.FINALS_END_POSITION - eliminationNormalizer) {
        return 'Finals';
    }
    if (index === roundCounts - eliminationNormalizer) {
        return 'Grand Final';
    }
    if (index === roundCounts) {
        return 'Champion';
    }
    return `Round ${index + 1}`;
};
exports.generateRoundShortTitle = generateRoundShortTitle;
//# sourceMappingURL=generate-round-short-title.js.map